import type { CalendarEvent } from '../../calendar/types/Calendar';
import { listConsultations } from '../services/consultationService';

export type EventConsultationNavigationTarget = {
  pathname: string;
  search?: string;
  state?: { returnTo?: string };
};

type EventConsultationSource = Pick<CalendarEvent, 'id' | 'appointmentTypeId' | 'contactId' | 'assetId' | 'assetIds'>;

export const buildCreateConsultationSearchParamsFromEvent = (event: EventConsultationSource): URLSearchParams => {
  const params = new URLSearchParams();
  params.set('eventId', event.id);

  if (event.appointmentTypeId) {
    params.set('appointmentTypeId', event.appointmentTypeId);
  }

  const assetId = event.assetIds?.[0] || event.assetId;
  if (assetId) {
    params.set('assetId', assetId);
  }

  if (event.contactId) {
    params.set('contactId', event.contactId);
  }

  return params;
};

export const resolveEventConsultationNavigation = async (
  event: EventConsultationSource,
  returnTo?: string,
): Promise<EventConsultationNavigationTarget> => {
  const assetId = event.assetIds?.[0] || event.assetId;
  const consultations = await listConsultations({
    eventId: event.id,
    page: 1,
    pageSize: 100,
  });

  const state = returnTo ? { returnTo } : undefined;
  const activeConsultations = consultations.filter((item) => !item.isDeleted);
  const preferred = activeConsultations.find((item) => assetId && item.assetId === assetId)
    ?? activeConsultations.find((item) => event.contactId && (item.contactId === event.contactId || item.customerContactId === event.contactId))
    ?? activeConsultations[0]
    ?? consultations[0];

  if (preferred?.id) {
    return {
      pathname: `/consultations/${preferred.id}`,
      state,
    };
  }

  const params = buildCreateConsultationSearchParamsFromEvent(event);

  return {
    pathname: '/consultations/new',
    search: `?${params.toString()}`,
    state,
  };
};
